// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "gf/css/" + chunkId + "." + "c81b82bbae8a3cb2cd23" + ".css";
};